/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_AdvancedInputs */

const en_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced`)
};

const es_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzado`)
};

const fr_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avancé`)
};

const de_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortgeschritten`)
};

const ja_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上級者向け`)
};

const zh_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级`)
};

const ar_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متقدم`)
};

const id_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjutan`)
};

const it_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avanzato`)
};

const ru_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продвинутый`)
};

const pt_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avançado`)
};

const ko_val_advanced = /** @type {(inputs: Val_AdvancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고급`)
};

/**
* | output |
* | --- |
* | "Advanced" |
*
* @param {Val_AdvancedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_advanced = /** @type {((inputs?: Val_AdvancedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_AdvancedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_advanced(inputs)
	if (locale === "es") return es_val_advanced(inputs)
	if (locale === "fr") return fr_val_advanced(inputs)
	if (locale === "de") return de_val_advanced(inputs)
	if (locale === "ja") return ja_val_advanced(inputs)
	if (locale === "zh") return zh_val_advanced(inputs)
	if (locale === "ar") return ar_val_advanced(inputs)
	if (locale === "id") return id_val_advanced(inputs)
	if (locale === "it") return it_val_advanced(inputs)
	if (locale === "ru") return ru_val_advanced(inputs)
	if (locale === "pt") return pt_val_advanced(inputs)
	return ko_val_advanced(inputs)
});